import { GetEntityId } from '../../../shared/gridEdit/useEditableGridLogic';
import { ScenarioObligation } from '../../../shared/queries/scenarios';

export const getScenarioObligationUniqueId: GetEntityId<ScenarioObligation> = rowData =>
  rowData.meta.isAdded
    ? null
    : `${rowData.companyCode}:${rowData.countryCode}:${rowData.countryTaxType}`;
